export default __webpack_public_path__ + "assets/home-two-one-small.55620ef1b33dcdb31e7c0acdb3e59700.png";